


















import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import { ITag } from "@/models/tags";
import { IClient } from "@/models/clients";

@Component({
  components: {
    "tags-provider": () =>
      import("@/components/app/global/tags/tagsProvider.vue"),
    "tags-view": () => import("@/components/app/global/tags/tagsView.vue")
  }
})
export default class ClientTags extends Mixins(RequestPromises) {
  // Props

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: "" })
  public scope!: string;

  @Prop({ default: false })
  public isDisabled!: string;

  @Prop({ default: false })
  public isAlignedCenter!: boolean;

  @Prop({ default: true })
  public updateStoreObject!: boolean;

  public get tags() {
    return this.client.tags || [];
  }

  public get clientTagIds() {
    return this.$_.map(this.tags, t => t.id);
  }

  // Methods

  public async assignTags(tagIds) {
    const tags = this.tags.filter(tag => tagIds.includes(tag.id));

    await this.$store.dispatch(`data/${DataModules.CLIENTS}/assignTags`, {
      id: this.client.id,
      tagIds
    });

    this.$bus.$emit("admin/client/tags/refresh", {
      client: this.client,
      tags
    });
  }

  public removeTagFromClientObject(tag: ITag) {
    this.updateTagsInStoredObject(
      this.$_.filter(this.tags, t => t.id !== tag.id)
    );
  }

  public updateTagsInStoredObject(tags: ITag[]) {
    if (!this.updateStoreObject) return;

    return this.$store.commit(`data/replaceData`, {
      data: {
        ...this.client,
        ...{
          tags
        }
      },
      scope: this.scope,
      storeModule: DataModules.CLIENTS
    });
  }

  public async syncAllTags(tags: ITag[]) {
    const newTagIds = tags.map(i => i.id);
    try {
      await this.assignTags(newTagIds);
      this.updateTagsInStoredObject(tags);

      this.$emit("tags-select-many", tags);

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.tags_updated")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public async unassignTag(tag) {
    if (!this.$userCan("attach_client_tag")) {
      this.$buefy.toast.open({
        message: this.$t("_sentence.permission_denied") as string,
        type: "is-danger"
      });
    }

    let tagIds = this.tags.map(t => t.id);
    tagIds = this.$_.filter(tagIds, id => id !== tag.id);

    try {
      await this.assignTags(tagIds);
      this.removeTagFromClientObject(tag);

      this.$emit("tag-close", tag);

      this.$store.dispatch("toast/show", {
        message: this.$t("_sentence.tag_unassigned")
      });
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }
}
